/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:59:42
 * @LastEditors: duanpengwei 1373513133@qq.com
 * @LastEditTime: 2025-08-19 17:35:51
 */
// 读取环境变量
// const ENV = process.env.RUNTIME_ENV
// 后端服务地址
export const postUrl = process.env.VUE_APP_API_HOST

export const apiUrl = postUrl + '/graphql'

export const reportHost = process.env.VUE_APP_PRINT_API_HOST

export const shareTime = process.env.VUE_APP_SHARE_TIME

console.log(`=================VUE_APP_FACEBOOK_LOGIN:${process.env.VUE_APP_FACEBOOK_LOGIN}`)
export const faceBookLogin = process.env.VUE_APP_FACEBOOK_LOGIN
console.log(`=================VUE_APP_GOOGLE_LOGIN:${process.env.VUE_APP_GOOGLE_LOGIN}`)
export const googleLogin = process.env.VUE_APP_GOOGLE_LOGIN

// 百度统计配置
export const baiduOptions = {
    siteId: process.env.HMT_ID,
}

// 上传静态文件路径
export const upyunUrl = process.env.UPLOAD_URL

// 维塑公众号id
export const appId = 'wxad26ae1d5bd54e89'

// export const qrcodeImg =
//     ['development', 'dev', 'test'].indexOf(ENV) > -1
//         ? require('@/assets/images/qrcode_for_gh_322a8987a12c_344.jpg')
//         : require('@/assets/images/qrcode.jpg')
